// extracted by mini-css-extract-plugin
module.exports = {"root":"CancelPendingInvoice_root__27L_q"};